import {Component, OnInit} from '@angular/core';
import * as qs from 'qs';
import {FilterFormService} from "../filter_form/filter_form.service";
import {Router} from "@angular/router";

@Component({
	selector: 'source-selector',
	template: `
		<div class="btn-group btn-group-sm" role="group" aria-label="Источник" *ngIf="showMe">
			<button
				*ngFor="let source of ['0', '1', '2']"
				type="button"
				[class]="filter.filterParams.source == source ? 'btn btn-info' : 'btn btn-outline-info'"
				(click)="setSource(source)"
			>
				{{ 'adminstat.common.clusters.' + source | translate }}
			</button>
		</div>
	`
})
export class SourceSelectorComponent implements OnInit {
	public showMe: boolean = true;
	constructor(
		private router: Router,
		public filter: FilterFormService,
	) {}

	async ngOnInit() {
		this.showMe = !(this.router.url.indexOf('/support') === 0);
	}

	setSource(source) {
		this.filter.filterParams.source = source;

		let url = this.router.url;
		let params = this.router.parseUrl(url).queryParams;
		params.source = source;
		params = qs.stringify(params, { encode: false });
		url = url.split('?')[0];

		this.router.navigateByUrl(`${url}?${params}`, { });
	}
}
